import * as React from 'react';

import CurriculumDetailContainer from '../../containers/CurriculumDetail';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * カリキュラム情報画面
 * @param props
 */
const CurriculumDetail: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('CurriculumDetail_0023')} />
			<CurriculumDetailContainer {...props} />
		</>
	);
};

export default CurriculumDetail;



// WEBPACK FOOTER //
// ./src/pages/personal/CurriculumDetail.tsx